<template>
  <qx-card-form title="账号信息">
    <el-alert
      :closable="false"
      title="温馨提示：1、不能4位或以上连号数字（如1234AB或4321AB）2、不能连续4位或以上相同（如AAAA2）3、不能与支付密码相同"
      type="warning"
    />
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <span slot="pwdTip" style="margin-left: 16px;">
        <span class="error" v-if="!$route.query.id">注：若新增时密码为空，初始密码默认为手机号码（即员工账号）后6位</span>
      </span>
    </qx-custom-form>

    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
import {
  getEnumList,
} from 'api';
import {
  mapState,
  mapMutations,
} from 'vuex';
export default {
  data () {
    return {
      baseForm: {
        lockFlagOptions: [],
        form: [
          {
            label: '账号名称',
            value: 'staffNickname',
            type: 'input',
            placeholder: '请输入账号名称',
          },
          {
            label: '员工账号',
            value: 'loginAcct',
            type: 'input',
            placeholder: '请输入手机号',
          },
          {
            label: '登录密码',
            value: 'pwd',
            type: 'input',
            placeholder: '请输入6-12位字母或数字',
            attr: {
              type: 'password',
            },
          },
          {
            label: '账号状态',
            value: 'lockFlag',
            type: 'select',
            default: '1',
          },
        ],
        rules: {
          staffNickname: [ // 账号名称
            { required: true, message: '请输入账号名称', trigger: 'blur' },
          ],
          loginAcct: [ // 员工账号
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { validator: this.checkMobile, trigger: 'blur' },
          ],
          pwd: [ // 登录密码
            { required: false, message: '请输入6-12位字母或数字', trigger: 'blur' },
            { validator: this.checkPwd, trigger: 'blur' },
          ],
          lockFlag: [ // 账号状态
            { required: true, message: '请输入账号状态', trigger: 'blur' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    async getDataTest () {
      this.sub();
    },

    checkPwd (rule, value, call) {
      if (value && value.length && value.length < 6) {
        // 如果填写了密码，则位数不能少于6位
        call('请输入6-12位字母或数字');
      } else {
        // 如果没填写密码，初始密码默认为手机号码（即员工账号）后6位，在 sub 处理
        call();
      }
    },

    async getList () {
      const enumsList = await getEnumList({
        codeType: 'ZH_USER_STATE',
      });
      this.baseForm.lockFlagOptions = enumsList[0];
    },

    async sub () {
      const formData = await this.$refs.baseForm.sub();
      if (formData) {
        if (!this.$route.query.id) {
          console.log(formData.pwd);
          if (formData.pwd === null || formData.pwd === undefined || formData.pwd === '') {
            // formData.pwd = formData.loginAcct.substring(formData.loginAcct.length - 6);
            // 密码为空时，后端做校验截取手机号六位（bug原因：不输入密码时，有时密码默认为123456，有时默认为手机号后6位）
            formData.pwd = '';
            console.log(formData.pwd);
          }
        }
        if (formData.pwd !== '') {
          formData.pwd = this.encode(formData.pwd);
        }
      }
      return formData;
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      return res;
    },
    async init (data = {}) {
      if (data.lockFlag !== undefined) {
        data.lockFlag = String(data.lockFlag);
      } else {
        // 默认为启用状态
        data.lockFlag = '1';
      }
      if (data.staffNickname === undefined) {
        data.staffNickname = this.userInfo.tenantName;
      }
      this.setFormAttrVal({
        form: this.baseForm,
        attr: '',
        value: Boolean(this.$route.query.id),
        names: ['staffNickname'],
      });
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: Boolean(this.$route.query.id),
        names: ['loginAcct'],
      });
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: Boolean(this.$route.query.id),
        names: ['pwd'],
      });
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
